import { FC, useMemo } from "react";
import { Box } from "@mui/material";
import { getCleanDialogGridColumnDefs } from "./resourceGridCleanDialogGridColumns";
import { ResourceType } from "@/services/cloudchipr.api";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";
import { resourceGridRowHeight } from "@/components/pages/common/resources-ag-grid/utils/constants/sizes";
import { AllTypeResourcesData } from "@/store/resources-grid/utils/types/resources";

interface ResourceGridCleanDialogGridProps {
  resourceType: ResourceType;
  data: AllTypeResourcesData[];
}

export const ResourceGridCleanDialogGrid: FC<
  ResourceGridCleanDialogGridProps
> = ({ resourceType, data }) => {
  const columnDefs = useMemo(
    () => getCleanDialogGridColumnDefs(resourceType),
    [resourceType],
  );

  if (!data) {
    return null;
  }

  const bordersHeight = data.length + 1;
  const boxHeight = (data.length + 1) * resourceGridRowHeight + bordersHeight;

  return (
    <Box
      border={1}
      maxHeight={300}
      minHeight={100}
      borderColor="grey.300"
      height={boxHeight}
    >
      <AgDataGrid
        rowData={data}
        loading={false}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        headerHeight={resourceGridRowHeight}
        rowHeight={resourceGridRowHeight}
      />
    </Box>
  );
};

const defaultColDef = {
  flex: 1,
  minWidth: 150,
  unSortIcon: true,
};
